import { createStore, combineReducers ,applyMiddleware} from 'redux'
import { composeWithDevTools } from "redux-devtools-extension";

import { persistStore, persistReducer } from 'redux-persist'
import { createLogger } from "redux-logger";

import storage from 'redux-persist/lib/storage'
import storageSession from 'redux-persist/lib/storage/session'
import { navigationReducer, modalCargadaReducer } from './reducers/navigation'
import { tokenReducer } from './reducers/token'
import { reintentosVU } from './reducers/reintentosVU'

import { usuarioReducer } from './reducers/usuario'
import { riesgoNetURLReducer, riesgoNetEnablerReducer } from './reducers/riesgoNet'
import { idClientAnalyticsReducer } from './reducers/idClientAnalytics'
import { plazoFijoActividadReducer } from './reducers/plazoFijo'
import { errorReducer } from './reducers/error'
import { plazoFijoInformacionObligatoria } from './reducers/plazoFijoInformacionObligatoria'
import { plazoFijoInformacionPersonal } from './reducers/plazoFijoInformacionPersonal'
import { plazoFijoInformacionDomicilio } from './reducers/plazoFijoInformacionDomicilio';
import { plazoFijoLandingPage } from './reducers/plazoFijoLandingPage';
import { plazoFijoPrimerFormulario } from './reducers/plazoFijoPrimerFormulario';
import { plazoFijoSimulador } from './reducers/plazoFijoSimulador';
import { plazoFijoConfirmacion } from './reducers/plazoFijoConfirmacion';
const persistConfig = {
    key: 'root',
    storage 
}



const rootReducer = combineReducers({
    navigation: navigationReducer,
    token: tokenReducer,
    reintentosVU: reintentosVU,
    usuario: usuarioReducer,
    riesgoURLNet: riesgoNetURLReducer,
    riesgoNetEnabler: riesgoNetEnablerReducer,
    modalCargada: modalCargadaReducer,
    idClientAnalytics: idClientAnalyticsReducer,
    plazoFijo: plazoFijoActividadReducer,
    error: errorReducer,
    plazoFijoInformacionObligatoria: plazoFijoInformacionObligatoria,
    plazoFijoInformacionPersonal: plazoFijoInformacionPersonal,
    plazoFijoInformacionDomicilio: plazoFijoInformacionDomicilio,
    plazoFijoLandingPage: plazoFijoLandingPage, //este es el simulador de la primer pagina
    plazoFijoPrimerFormulario: plazoFijoPrimerFormulario,
    plazoFijoSimulador: plazoFijoSimulador, //este es el simulador del ultimo paso del stepper
    plazoFijoConfirmacion: plazoFijoConfirmacion
});

const persistedReducer = persistReducer(persistConfig, rootReducer)

const logger = createLogger({
    collapsed: true,
    diff: true
});

let middlewares = []

let enviroment = process.env.REACT_APP_APP_ENV || "dev"
if(enviroment !== "prod"){
    middlewares.push(logger)
}

export const store = createStore(
        persistedReducer,    
        composeWithDevTools( applyMiddleware( ...middlewares ) )
);

export const persistor = persistStore(store);





// WEBPACK FOOTER //
// ./src/store/configure.js